import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { Modal } from '@beef/ui-kit';
import { AcceptInvitation } from '../../components/AcceptInvitation';
import { InvitationStatus } from '../InvitationStatus';

// Constants
import { INCOMING_POPUP_STEPS } from '../../constants';

// HOCS
import { IncomingInviteHOC } from '../../hocs/IncomingInviteHOC';

// Actions
import { getIncomingInviteFetch, showInvitationStatus, toggleIncomingInviteModal } from '../../store/actions';

const IncomingInvitationPopup = () => {
  const dispatch = useDispatch();
  const { incomingInvitation } = useSelector((state) => state.application);
  const { isOpen, step } = incomingInvitation;

  const handleCloseModal = useCallback(() => {
    if (step === INCOMING_POPUP_STEPS.incomingInvite) {
      dispatch(showInvitationStatus(true));
    }
    dispatch(toggleIncomingInviteModal(false));
  }, [step]);

  useEffect(() => {
    dispatch(getIncomingInviteFetch());
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      isCentered
      onClose={handleCloseModal}
      size="xs"
    >
      {step === INCOMING_POPUP_STEPS.incomingInvite && (
        <IncomingInviteHOC>
          <AcceptInvitation />
        </IncomingInviteHOC>
      )}
      {(step === INCOMING_POPUP_STEPS.accept
          || step === INCOMING_POPUP_STEPS.reject
          || step === INCOMING_POPUP_STEPS.error) && (
          <InvitationStatus status={step} />
      )}
    </Modal>
  );
};

export { IncomingInvitationPopup };
